module.exports = __webpack_public_path__ + "static/img/logo7.9cfddf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo7.jpg
// module id = h+mq
// module chunks = 2